<template>
  <!-- 我的作品-->
  <div class="opus-reveal">
    <!-- 详情页-->
    <div class="opus-reveal-con">
      <div class="opus-reveal-title">
        <span class="title">作品展示</span>
        <div class="opus-reveal-sort">
          <span>排序:</span>
          <div class="sort-style">
            <span v-for="(item,index) in sortStyle" :class="{'active' : sortNum ==index }" @click="changeSortNum(index, item.type)">{{item.name}}</span>
          </div>
        </div>
      </div>

      <div class="no-work" v-if="noWorkList && !this.$store.state.isMobile">目前还没有人上传作品，快来上传作品吧！</div>
      <div class="no-work" v-if="noWorkList && this.$store.state.isMobile">
        <p>目前还没有人上传作品</p>
        <p>快来上传作品吧！</p>
      </div>
      <ul class="opus-reveal-list" ref="opuslist" v-if="!noWorkList">
          <li v-for="item in worksList" @click="toOpushInfo(item.work_id, item.name)">
            <img :src="item.url" alt="">
            <div class="reveal-info">
              <p class="reveal-info-title">{{ item.name }}</p>
              <div class="reveal-info-con">
                <span class="name">{{ item.nickname }}</span>
                <span class="num">
                  <img src="../assets/images/thumbs-up.png" alt="">
                  {{ item.votes }}
                </span>
              </div>
            </div>
          </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "OpusReveal",
  data() {
    return{
      sortStyle :[
        {name:'最新', type: 1},
        {name:'点赞最多', type: 2},
        {name:'推荐', type: 0},
      ],
      sortNum: 0,
      worksList: [],
      page: 1,
      pageSize: 1000000,
      // 页面级变量
      pageRecord:{
        title:'precision25周年',
        module: 'precision25周年',
        category1: '作品列表页',
      },
      opuslistHeight: '',
      mobid: false,
      orderType: '1',
      noWorkList: false,
    }
  },
  mounted() {
    // this.mobid = this.$store.state.isMobile
    this.getWorksList()
    this.$nextTick(()=>{
      //
      // if(!this.$store.state.isMobile){
      //   let $ele = this.$refs.opuslist;
      //   let width;
      //   width = $ele.clientWidth * 0.23;
      //   this.opuslistHeight = width/16*9 + 'px'
      // }

    })
  },
  methods: {
    changeSortNum(index,style) {
      console.log(index)
      this.sortNum = index;
      this.orderType = style
      this.getWorksList()
    },
    // 获取作品列表
    getWorksList() {
      this.worksList = []
      this.$api.worksList(this.page, this.pageSize, this.orderType)
          .then(res=>{
            if(res.data.items.length !== 0){
              this.noWorkList = false;
              this.worksList = res.data.items;
            }else{
              this.worksList = [];
              this.noWorkList = true;
            }
          })
    },
    //作品列表
    toOpushInfo(workId, name) {
      // 点击作品埋点
      this.gioAction('precision25thart_workpreviewClick', {'workstitle':name});

      //改变workId
      this.$tool.setLS('workId',  workId,1)
      this.$router.push({path:'/opusInfo', query: { id: workId }});
    }
  }
}
</script>

<style scoped lang="less">
@import "../assets/css/OpusReveal/pc";
@import "../assets/css/OpusReveal/wap";
</style>
